import { Pipe, PipeTransform } from '@angular/core';
import { StringUtil } from 'src/app/util/string-util';
@Pipe({ name: 'mailObfuscate' })
export class MailObfuscatePipe implements PipeTransform {
  transform(mail: string): string {
    if (!mail) return '-';
    return StringUtil.obfuscateMail(mail);
  }
}